/* eslint-disable */
import DirectionFactory from "../Factory/Direction";
import DirectionsRepository from '@/js/common/Domain/Repository/Directions';

DirectionsRepository.repository.init = function(options) {
	var directionsModelsArray = [],
		directions = options.directions,
		prices = options.prices;

	_.each(directions, function(direction) {
		var directionModel = new DirectionFactory({
			data:direction,
			prices:prices
		});
		directionsModelsArray.push(directionModel);
	});
	this.set(directionsModelsArray);
};

export default DirectionsRepository;